module.exports = __webpack_public_path__ + "static/media/poolImage3.93695c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pics/poolImage3.jpg
// module id = 91
// module chunks = 0